export default __webpack_public_path__ + "static/media/instant_deployment_number.51224186.svg";